import { render, staticRenderFns } from "./AppCentricInspections.vue?vue&type=template&id=6d2b6e20&scoped=true"
import script from "./AppCentricInspections.vue?vue&type=script&lang=js"
export * from "./AppCentricInspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b6e20",
  null
  
)

export default component.exports